module.exports = __webpack_public_path__ + "img/strawberry.bf2de15a.svg";